module.exports = __webpack_public_path__ + "img/manas.b3dfeeb8.png";